import { render, staticRenderFns } from "./WyhSettingBase.vue?vue&type=template&id=6b4c6fbc&scoped=true&"
import script from "./WyhSettingBase.vue?vue&type=script&lang=js&"
export * from "./WyhSettingBase.vue?vue&type=script&lang=js&"
import style0 from "./WyhSettingBase.vue?vue&type=style&index=0&id=6b4c6fbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c6fbc",
  null
  
)

export default component.exports